import { createHTMLSandbox, formatTextToId } from '@hozana/dom/functions'

import { POPIN_CLOSE_BUTTON_ID, POPIN_CONTAINER_ID, POPIN_ID, POPIN_OVERLAY_ID } from 'general/constants'

import { PARTNER } from 'modules/guide/constants'

import { TGuide } from './types'

export const getGuideTitles = (guideContent: string) => {
  const sandbox = createHTMLSandbox(guideContent)
  const h2List = sandbox.querySelectorAll('h2')

  return Array.from(h2List, (title) => {
    const titleId = formatTextToId(title.textContent)
    if (titleId) {
      return { textContent: title.textContent, id: titleId }
    }
    return null
  }).filter(Boolean)
}

export const getPartnerLink = (partner: PARTNER, slug: TGuide['slug'], guideName: string, id: number, lang: string) =>
  partner === 'rosario'
    ? `https://app.adjust.com/1hj527qp?deep_link=rosario%3A%2F%2F&campaign=o_rosario_app&adgroup=${id}&creative=first_modal&fallback=https%3A%2F%2Frosario.app%2F&redirect_macos=https%3A%2F%2Frosario.app%2F${
        lang === 'fr' ? '' : `${lang}%2F`
      }`
    : `https://app.adjust.com/ojwnd6v?deep_link=meditatio%3A%2F%2F&campaign=Hozana_affilie&adgroup=Guide_${guideName}&creative=modale_${slug}&fallback=https%3A%2F%2Fmeditatio.app%2F&redirect_macos=https%3A%2F%2Fmeditatio.app%2F`

// /!\ Also defined in full-ssr-functions.js
export const getPopinId = (id: string, number: number, variant?: string) =>
  `${id}-${number}` + (variant ? `-${variant}` : '')

export const getPopinIds = (number: number, variant?: string) => ({
  closeButton: getPopinId(POPIN_CLOSE_BUTTON_ID, number, variant),
  container: getPopinId(POPIN_CONTAINER_ID, number, variant),
  overlay: getPopinId(POPIN_OVERLAY_ID, number, variant),
  popin: getPopinId(POPIN_ID, number, variant),
})
